import React from "react";
import BasketballBlock from "../components/Basketball/BasketballBlock";

export default function Basketball() {
    return (
        <section>
            <BasketballBlock />
        </section>
    );
}